import { apolloClient } from "../../../vue-apollo";
import {
  GET_VALORES,
  DASHBOARD_RECONOCE,
  GET_INDICADORES_RECONOCIMIENTOS_ANUALES,
  GET_INDICADORES_RECONOCEDORES_ANUALES,
  GET_RECONOCIDOS_MONTH,
  GET_GERENCIAS,
  GET_GERENCIAS_DATA,
  GET_SUCURSALES,
  GET_RECONOCIMIENTO_PLANTA,
  GET_RECONOCIMIENTOS_USUARIO,
  GET_RECONOCIMIENTOS_REPORTE,
  FIND_ALL_VALORES_COMPORTAMIENTOS,
  FIND_DATA_EMPRESA_RECONOCIMIENTOS,
} from "../../../apollo/queries";
import { ADD_RECOGNIZE, DEL_RECOGNIZE } from "../../../apollo/mutations";
import { exQue } from "@/utils/gql";

export default {
  namespaced: true,
  state: {
    data_gerencias: [{ id: "0", type: "Todas", label: "Todas" }],
    data_sucursales: [{ id: "0", type: "Todas", label: "Todas" }],
    valores: [],
    valoresAll: [],
    empRecognizes: []
  },

  mutations: {
    setFindRec(state, data) {
      state.empRecognizes = data;
    },

    addGerencias(state, gerencias) {
      state.data_gerencias = [{ id: "0", type: "Todas", label: "Todas" }];
      if (Array.isArray(gerencias)) {
        gerencias.forEach((gerenciaObj) => {
          state.data_gerencias.push({
            id: gerenciaObj.id_gerencia,
            type: gerenciaObj.__typename,
            label: gerenciaObj.nombre_gerencia,
          });
        });
      }
    },
    addSucursales(state, sucursales) {
      state.data_sucursales = [{ id: "0", type: "Todas", label: "Todas" }];
      if (Array.isArray(sucursales)) {
        sucursales.forEach((sucursalObj) => {
          state.data_sucursales.push({
            id: sucursalObj.id_sucursal,
            type: sucursalObj.__typename,
            label: sucursalObj.nombre_sucursal,
          });
        });
      }
    },
    setValores(state, valores) {
      state.valores = [];
      if (Array.isArray(valores)) {
        state.valores = valores.map((valor) => ({
          id: valor.id_valor,
          type: valor.__typename,
          label: valor.nombre_valor,
        }));
      }
    },
    setValoresAll(state, valoresAll) {
      state.valoresAll = [];
      if (Array.isArray(valoresAll)) {
        state.valoresAll = valoresAll.map((valor) => ({
          id: valor.valor.id_valor,
          id_comportamiento: valor.id_valor_comportamiento,
          type: valor.__typename,
          label: valor.valor.nombre_valor,
        }));
      }
    },
    addReconocimiento(state, reconocimiento) {
      if (!state.empRecognizes || !state.empRecognizes.reconocimientos) {
        state.empRecognizes.reconocimientos = [];
      }
      state.empRecognizes.reconocimientos.unshift(reconocimiento);

  },
    delReconocimiento(state, id) {
      if (!state.empRecognizes || !state.empRecognizes.reconocimientos) return;
      state.empRecognizes.reconocimientos = state.empRecognizes.reconocimientos.filter(
        (reconocimiento) => reconocimiento.id_reconocimiento != id
      );
    },
  },

  actions: {
    async getValoresAction({ commit }) {
      const params = {
        query: GET_VALORES,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) data = response.data.valoresReconocimientos;
        response = data;
      } catch (e) {
        console.error(e);
      }
      if (response) {
        commit("setValores", response);
      }
      return response;
    },

    async findAllValoresComportamientosAction({ commit }) {
      const params = {
        query: FIND_ALL_VALORES_COMPORTAMIENTOS,
        fetchPolicy: "network-only",
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) data = response.data.FindAllValoresComportamientos;
        response = data;
      } catch (e) {
        console.error(e);
      }
      if (response) {
        commit("setValoresAll", response);
      }
      return response;
    },

    async getEstadisticasReconocimientosAction(_, data) {
      const params = {
        query: DASHBOARD_RECONOCE,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) data = response.data.DashboardReconocimientos;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getCantidadReconocimientosAnualAction(_, data) {
      const params = {
        query: GET_INDICADORES_RECONOCIMIENTOS_ANUALES,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading)
          data = response.data.IndicadoresReconocimientosAnuales;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getCantidadReconocedoresAnualAction(_, data) {
      const params = {
        query: GET_INDICADORES_RECONOCEDORES_ANUALES,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading)
          data = response.data.IndicadoresReconocedoresAnuales;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },
    async getReconocidosAction(_, data) {
      const params = {
        query: GET_RECONOCIDOS_MONTH,
        variables: data,
      };

      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading)
          data = response.data.totalReconocidosYearMonthReconocimientos;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },
    async getReconocimientosGerenciasAction(_, data) {
      const params = {
        query: GET_GERENCIAS_DATA,
        variables: data,
        fetchPolicy: "network-only",
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading)
          data = response.data.reconocimientosGerenciasYearMonth;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getGerenciasAction({ commit }, data) {
      const params = {
        query: GET_GERENCIAS,
        variables: data,
        fetchPolicy: "network-only",
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) data = response.data.gerencias;
        response = data;
        commit("addGerencias", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getSucursalesAction({ commit }, data) {
      const params = {
        query: GET_SUCURSALES,
        variables: data,
        fetchPolicy: "network-only",
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) data = response.data.sucursales;
        response = data;
        commit("addSucursales", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getReconocimientosPlantaAction(_, data) {
      const params = {
        query: GET_RECONOCIMIENTO_PLANTA,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading)
          data = response.data.reconocimientosPlantaYearMonth;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async findReconocimientosByUsernameAction(_, data) {
      const params = {
        query: GET_RECONOCIMIENTOS_USUARIO,
        variables: data,
      };
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading)
          response = res.data.reconocidosYearMonthReconocimientosName;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getReconocimientosReporteAction(_, data) {
      const params = {
        query: GET_RECONOCIMIENTOS_REPORTE,
        variables: data,
      };
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.reconocimientosReportes;
      } catch (e) {
        console.error(e);
      }
      return response;
    },
    async findRec({ commit }, id_tipo = 1) {
      const data = await exQue(FIND_DATA_EMPRESA_RECONOCIMIENTOS, {id_tipo}, true);
      commit("setFindRec", data);
    },
    async addReconocimientoAction(
       { commit },
      { id_tipo_reconocimiento, reconocido, valor, sucursal }
    ) {
      const params = {
        mutation: ADD_RECOGNIZE,
        variables: {
          id_tipo_reconocimiento,
          reconocido,
          valor,
          sucursal,
        },
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.AgregarReconocimientoMural;
        commit("addReconocimiento", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },
    async delReconocimientoAction({ commit }, id) {
      const params = {
        mutation: DEL_RECOGNIZE,
        variables: { id_reconocimiento: id },
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.RemoveReconocimientoMural;

        commit("delReconocimiento", id);
      } catch (e) {
        console.error(e);
      }
      return response;
    },
  },
};
